import { SUPPLY_TARGETING_TYPES } from '../../common-campaign-form/components/SupplyTargeting/const';

export const isMailTargeting = campaign => campaign?.campaignTargeting?.supplyTargeting === SUPPLY_TARGETING_TYPES.MAIL;
